module.exports = __webpack_public_path__ + "34095380a438b55125a28302eb66877a.png";